import { BASE_URL } from '../utils/constants';
import { AXIOS_INSTANCE } from '.';

export const getPublicWhatsappLinksAPI = async () => {
  try {
    const { data } = await AXIOS_INSTANCE.get(
      `${BASE_URL}/public/whatsapp-link`
    );
    return data;
  } catch (error) {
    return error;
  }
};
